import { Routes, RouterModule } from '@angular/router';
import { DemoFormComponent } from './application/web-components/demo-form/demo-form.component';

export const AppRoutes: Routes = [
  {
    path: '',
    redirectTo: '/superadmin/dashboard/index',
    pathMatch: 'full',
  },
  {
    path: 'authenticate',
    loadChildren: './application/authenticate/authenticate.module#AuthenticateModule'
  },
  {
    path: 'superadmin',
    loadChildren: './application/web-components/web.module#WebModule'
  },
  {
    path: 'systemadmin',
    loadChildren: './application/web-components/web.module#WebModule'
  },
  {
    path: 'schooladmin',
    loadChildren: './application/web-components/web.module#WebModule'
  },
  {
    path: 'template',
    loadChildren: './application/template/templates.module#TemplatesModule'
  },
  {
    path: 'mentor',
    loadChildren: './application/web-components/web.module#WebModule'
  },
  {
    path: 'demo_form',
    component: DemoFormComponent
  },
  {
    path: '**',
    redirectTo: '/error',
    pathMatch: 'full',
  },
];



// WEBPACK FOOTER //
// ./src/app/app.routing.ts